import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex);

export default new Vuex.Store({
  state: {

    // list_stadiums:[],//全部酒店数据
    // list_myCards:[],//我的会员卡
    // string_isLoadedMyCard:false,//是否需要再次获取我的会员卡列表


    //--------------v2.2--------------
    // fl_cityList:[],//城市列表
    array_mycard:[],//我的会员卡
    object_userinfo:null,//用户信息
    array_cityList:[],//城市列表
    array_cityList_stadium:[],//城市列表(场馆列表)
    test:0
  },
  mutations: {
    // // 更新全部酒店列表
    settestStadiums(state){
      state.test = 2;
    },
    // // 更新我的会员卡数据
    // setMyCards(state,list_myCards){
    //   state.list_myCards = list_myCards;
    // },
    // // 更新 string_isLoadedMyCard 数据
    // setIsLoadedMyCard(state,isLoadedMyCard){
    //   state.string_isLoadedMyCard = isLoadedMyCard;
    // },
    // // 更新城市列表数据
    // updateCityList(state,fl_cityList){
    //   state.fl_cityList = fl_cityList
    // },

    //--------------v2.2--------------
    // 更新我的会员卡
    updataMycard(state,array_mycard){
      state.array_mycard = array_mycard
    },
    // 更新我的信息
    updataMyInfo(state,object_userinfo){
      state.object_userinfo = object_userinfo
    },
    // 更新信息
    updataCityList(state,array_cityList){
      state.array_cityList = array_cityList
    },
    updataCityListST(state,array_cityList_stadium){
      state.array_cityList_stadium = array_cityList_stadium
    },


    /**
     * 更新会员卡时机：
     * 1、首页：存在 token 时，若无会员卡信息，则更新一下
     * 2、登录注册：当用户完成登录注册，重置会员卡数组信息
     * 3、激活：完成激活，重置会员卡数组信息
     * 4、酒店列表：存在 token 时，若无会员卡信息，则更新一下
     * 5、酒店详情：存在 token 时，若无会员卡信息，则更新一下
     * 6、创建订单：无卡下单不需要操作；
     *             有卡若无会员卡信息，则更新一下；
     *             下单结束，重置会员卡数组信息[包括权益下单、微信支付]；
     * 7、我的企业会员：若无会员卡信息，则更新一下
     * 8、vip页：若无会员卡信息，则更新一下
     *           购卡成功，重置会员卡数组信息
     * 9、秒杀活动：会员卡数据暂时独立
     * 10、订单退订需要更新一下
     * 11、领取优惠券页面，若无会员卡信息更新一下
     *
     * 更新用户信息
     * 1、场馆列表页，若存在token且无用户信息时，需更新
     * 2、场馆详情页，若存在token且无用户信息时，需更新
     * 3、实名成功，需更新
     * 4、个人页面，若存在token且无用户信息时，需更新
     * 5、领取优惠券页面，若存在token且无用户信息时，需更新
     * 5、激活页面，若存在token且无用户信息时，需更新
     */
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js